<mat-form-field class="fuse-mat-no-subscript w-full" [formGroup]="form" [ngClass]="classes" [floatLabel]="floatLabel">
    <mat-label>{{ label }}</mat-label>
    <input [required]="required" type="text" matInput [imask]="phoneMask" [unmask]="true" [placeholder]="placeholder"
        autocomplete="tel" [formControlName]="controlName" />
</mat-form-field>